<template>
  <app-dialer-common-page
    class="app-dialer-actions-page"
    :title="title"
    @go-back="$emit('go-back')"
  >
    <app-dialer-transfer-content
      :avatar="avatar"
      :agents="agentOptions"
      :rule-groups="ruleGroups"
      :tabs="content"
      :agent-actions-type="actionsType"
      :context="context"
      :statuses="statuses"
      :default-search-options="defaultSearchOptions"
      :can-change-search-options="canChangeSearchOptions"
      :show-agents-tab="showAgentsTab"
      :are-agent-actions-disabled="isPerformingAction"
      :can-invite-third-party="canInviteThirdParty"
      tabs-type="compact"
      actions-type="popup"
      size="mobile"
      @invite-agent="onInviteAgent"
      @invite-3rd-party="onInvite3rdParty"
    />
  </app-dialer-common-page>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue-demi';

import AppDialerCommonPage from '../../components/common/AppDialerCommonPage.vue';
import AppDialerTransferContent from '../../components/controls/AppDialerTransferContent.vue';
import {
  useCommonProps,
  useDialerStore,
  useAgentActionsProps,
  useAgentsActions,
} from '../../composables';

export default defineComponent({
  name: 'AppDialerActionsPageContainer',
  components: {
    AppDialerCommonPage,
    AppDialerTransferContent,
  },
  props: {
    actionsType: {
      type: String as PropType<'invite' | 'transfer'>,
      default: 'invite',
    },
  },
  setup(props) {
    const { avatar, ruleGroups, statuses } = useCommonProps();
    const { tabs, isPerformingAction, agentOptions } = useDialerStore();
    const {
      title,
      showAgentsTab,
      content,
      context,
      canInviteThirdParty,
      defaultSearchOptions,
      canChangeSearchOptions,
    } = useAgentActionsProps(props);
    const { onInviteAgent, onInvite3rdParty } = useAgentsActions(props);

    return {
      avatar,
      agentOptions,
      ruleGroups,
      statuses,
      tabs,
      title,
      showAgentsTab,
      content,
      context,
      canInviteThirdParty,
      defaultSearchOptions,
      canChangeSearchOptions,
      isPerformingAction,
      onInviteAgent,
      onInvite3rdParty,
    };
  },
});
</script>

<style lang="scss" scoped>
.app-dialer-actions-page {
  & > ::v-deep .content {
    display: flex;
    flex-direction: column;
  }

  [data-component='app-dialer-transfer-content'] {
    flex: 1 1 100%;
  }
}
</style>
